import type { QueryHook } from 'react-query-kit';
import type { GooglePlace } from './GooglePlace';

export type PlaceId = string;

export interface LookupOpts {
  readonly language?: string;
  readonly region?: string;
}

export enum TravelMode {
  Walking,
  Driving,
}

export interface DistanceResponse {
  readonly origin: PlaceId;
  readonly destination: PlaceId;
  readonly travelMode: TravelMode;
  readonly distanceMeters: number;
}

export interface GooglePlacesApi {
  readonly lookup: (placeId: PlaceId, opts?: LookupOpts) => QueryHook<GooglePlace>;
  readonly distance: (origin: PlaceId, destination: PlaceId, travelMode: TravelMode) => QueryHook<DistanceResponse>;
}
